import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Button from 'components/inputs/button';

type EquipmentSystemsErrorNoteProps = {
  failedCount: number;
  isRetrying: boolean;
  onRetry: () => void;
};

export default function EquipmentSystemsErrorNote({
  failedCount,
  isRetrying,
  onRetry
}: EquipmentSystemsErrorNoteProps) {
  const configLabel = failedCount === 1 ? 'configuration' : 'configurations';

  return (
    <div className='w-full rounded-lg bg-red-50 px-4 py-3 text-red-700 shadow'>
      <div className='flex items-center gap-3'>
        <ExclamationTriangleIcon className='h-5 w-5 flex-shrink-0' />
        <div className='grow text-sm'>
          {`We couldn't load systems for ${failedCount} ${configLabel}. This is usually temporary.`}
        </div>
        <Button
          color='red'
          text={isRetrying ? 'Retrying...' : 'Retry'}
          onClick={onRetry}
          disabled={isRetrying}
          loading={isRetrying}
        />
      </div>
    </div>
  );
}
